import { Box, Grid2, IconButton, Typography } from "@mui/material";
import { Gauge, gaugeClasses } from "@mui/x-charts/Gauge";
import React from "react";
import AnalysisIco from "../../../../assets/icons/AnalysisIco";
import ErrorCodeIco from "../../../../assets/icons/ErrorCodeIco";
import ExclamatoryIco from "../../../../assets/icons/ExclamatoryIco";
import { HandleSkeletion } from "../../../../utils/constants";
import { CustomDiv } from "../../../chat-bot/style";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import { CustomPaper } from "../../../resume-intelligence/Style";
import { CustomUnOrderList } from "../../style";
import Comparison from "./Comparison";
import CandidateFitIco from "../../../../assets/icons/CandidateFitIco";

function SkillRating({ label, score, handleScoreChange, spiderGraph }) {
  const color = score >= 75 ? "#47CD89" : score >= 30 ? "#FDB022" : "red";

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      mx={1.5}
      sx={{ cursor: handleScoreChange === "" ? "auto" : "pointer" }}
      onClick={() => (handleScoreChange === "" ? {} : handleScoreChange(label))}
    >
      <Gauge
        width={90}
        height={90}
        value={score}
        cornerRadius="50%"
        text={({ value, valueMax }) => `${score}%`}
        sx={(theme) => ({
          [`& .${gaugeClasses.valueText}`]: {
            fontSize: spiderGraph ? 13 : 14,
            color: "#101828",
            fontWeight: 600,
          },
          [`& .${gaugeClasses.valueArc}`]: {
            fill: color,
          },
        })}
      />
      <Typography fontSize={"12px"} color={"#475467"} fontWeight={600}>
        {label}
      </Typography>
    </Box>
  );
}

function FeedbackCard({
  icon,
  message,
  marginBottom,
  background,
  border,
  title,
}) {
  return (
    <CustomPaper
      variant="outlined"
      width="100%"
      padding={"14px"}
      marginBottom={marginBottom}
      display={"flex"}
      alignItems={"start"}
      background={background}
      border={border}
      gap={"1rem"}
    >
      <CustomDiv>{icon}</CustomDiv>
      <CommonGrid2 display={"flex"} flexDirection={"column"} gap={"10px"}>
        <Typography fontSize={"17px"} fontWeight={600} color={"#00144A"}>
          {title}
        </Typography>
        <Typography fontSize={"15px"} fontWeight={500} color={"#00144A"}>
          {message}
        </Typography>
      </CommonGrid2>
    </CustomPaper>
  );
}

const RedFlag = ({
  icon,
  message,
  marginBottom,
  background,
  border,
  title,
}) => (
  <CustomPaper
    variant="outlined"
    width="100%"
    padding={"14px"}
    marginBottom={marginBottom}
    display={"flex"}
    alignItems={"start"}
    gap="1rem"
    background={background}
    border={border}
  >
    <CustomDiv>{icon}</CustomDiv>
    <CustomDiv>
      <Typography fontSize={"17px"} fontWeight={600}>
        {title}
      </Typography>
      <CustomUnOrderList
        padding="0px 0px 0px 25px"
        margin="10px 0px"
        gap="10px"
        fontSize="15px"
      >
        {message?.map((item, index) => (
          <li>{item}</li>
        ))}
      </CustomUnOrderList>
    </CustomDiv>
  </CustomPaper>
);

function MatchingSummary({
  matchedData,
  handleScoreChange,
  loading,
  spiderGraph = false,
  handleQuestionMarkClick,
  iconVisible,
  chatBotData,
}) {
  return (
    <Box>
      <CustomPaper
        variant="outlined"
        width="100%"
        padding={"12px"}
        marginBottom={"16px"}
      >
        <Grid2
          container
          justifyContent="center"
          alignItems={"center"}
          spacing={2}
        >
          <CommonGrid2
            item
            display={"flex"}
            size={{ xs: 12, md: 5, sm: 12 }}
            container
            justifyContent={"center"}
            spacing={2}
            alignItems={"center"}
            width={spiderGraph ? "auto" : "100% !important"}
          >
            {loading ? (
              Array.from({ length: 5 }).map((_, index) => (
                <HandleSkeletion
                  height={100}
                  width={100}
                  marginRight={"1rem"}
                />
              ))
            ) : (
              <>
                <CommonGrid2 display={"flex"}>
                  {matchedData?.match_summary &&
                    matchedData?.match_summary
                      ?.slice(0, 3)
                      .map((item, index) => (
                        <Grid2 item>
                          <SkillRating
                            label={item.name}
                            score={item.score}
                            handleScoreChange={handleScoreChange}
                            spiderGraph={spiderGraph}
                          />
                        </Grid2>
                      ))}
                </CommonGrid2>

                <CommonGrid2 display={"flex"}>
                  {matchedData?.match_summary &&
                    matchedData?.match_summary
                      ?.slice(3, 5)
                      .map((item, index) => (
                        <Grid2 item>
                          <SkillRating
                            label={item.name}
                            score={item.score}
                            handleScoreChange={handleScoreChange}
                            spiderGraph={spiderGraph}
                          />
                        </Grid2>
                      ))}
                </CommonGrid2>
              </>
            )}
          </CommonGrid2>
          {spiderGraph && (
            <Grid2 item size={{ xs: 12, md: 7, sm: 12 }}>
              <Comparison matchedData={matchedData} loading={loading} />
            </Grid2>
          )}
        </Grid2>
      </CustomPaper>

      {/* {loading ? (
        <HandleSkeletion height={100} width={"100%"} marginRight={"1rem"} />
      ) : (
        <FeedbackCard
          message={matchedData?.insights?.feedback?.analysis}
          icon={<AnalysisIco />}
          marginBottom="16px"
          background="#EBF8FF"
          border="none !important"
          title={
            <CommonGrid2 display={"flex"} alignItems={"baseline"} gap={"1px"}>
              Analysis: Meets Expectations of Job Duties
              <IconButton
                onClick={() =>
                  handleQuestionMarkClick(
                    chatBotData.geminiBubble &&
                      chatBotData.geminiBubble.length !== 0
                      ? chatBotData.geminiBubble.filter(
                          (item) => item.question === "Candidate Accomplishment"
                        )[0]
                      : chatBotData.bubble.filter(
                          (item) => item.question === "Candidate Accomplishment"
                        )[0]
                  )
                }
                style={{ opacity: !iconVisible ? 0.5 : 1, marginTop: "-10px" }}
                disabled={!iconVisible}
              >
                <CandidateFitIco />
              </IconButton>
            </CommonGrid2>
          }
        />
      )}

      {loading ? (
        <HandleSkeletion height={100} width={"100%"} marginRight={"1rem"} />
      ) : (
        <RedFlag
          message={matchedData?.insights?.feedback?.red_flags}
          icon={<ExclamatoryIco size="30px" />}
          marginBottom="10px"
          background="#FFFAE3"
          border={"none !important"}
          title={"Red Flags"}
        />
      )}

      {loading ? (
        <HandleSkeletion height={100} width={"100%"} marginRight={"1rem"} />
      ) : (
        <>
          {matchedData &&
            matchedData?.insights &&
            matchedData?.insights &&
            matchedData?.insights &&
            matchedData?.insights?.feedback &&
            matchedData?.insights &&
            matchedData?.insights?.feedback?.qm_errors && (
              <>
                <Typography
                  fontSize={"20px"}
                  fontWeight={600}
                  color={"#101828"}
                  marginBottom={"10px"}
                  marginTop={"1rem"}
                >
                  {"Data Error"}
                </Typography>

                {matchedData?.insights?.feedback?.qm_errors?.map(
                  (item, index) => (
                    <CustomPaper
                      variant="outlined"
                      width="100%"
                      padding={"12px"}
                      marginBottom={"10px"}
                      display={"flex"}
                      alignItems={"start"}
                      gap="14px"
                    >
                      <div>
                        <ErrorCodeIco />
                      </div>
                      <CommonGrid2
                        display={"flex"}
                        alignItems={"flex-start"}
                        gap={"4px"}
                        flexDirection={"column"}
                      >
                        <Typography
                          fontSize={"16px"}
                          fontWeight={700}
                          color={"#D80027"}
                        >
                          Error Code : {item.code}
                        </Typography>

                        <Typography
                          fontSize={"14px"}
                          fontWeight={500}
                          color={"#00144A"}
                        >
                          {item.message}
                        </Typography>
                      </CommonGrid2>
                    </CustomPaper>
                  )
                )}
              </>
            )}
        </>
      )} */}
    </Box>
  );
}

export default MatchingSummary;
